<section class="flex flex-col max-w-full p-2 mt-8">
  <h1 class="p-2 text-center bg-gray-800 border-4 border-gray-700 border-solid">
    <span>Benutzer erstellen</span>
  </h1>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="grid grid-cols-2 gap-2 p-4 mx-auto mt-8 bg-gray-900 border-8 border-gray-700 border-solid rounded-lg max-w-lg">
    <label for="name" class="px-2 bg-gray-800 border-2 border-gray-800 border-solid">Name</label>
    <input id="name" type="text" formControlName="name" class="px-2 text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300">
    
    <label for="password" class="px-2 bg-gray-800 border-2 border-gray-800 border-solid">Passwort</label>
    <input id="password" type="password" formControlName="password" class="px-2 text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300">
    
    <label for="passwordConfirmation" class="px-2 bg-gray-800 border-2 border-gray-800 border-solid">Bestätigung</label>
    <input id="passwordConfirmation" type="password" formControlName="passwordConfirmation" class="px-2 text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300">
    
    <label for="playerId" class="px-2 bg-gray-800 border-2 border-gray-800 border-solid">Spieler-ID</label>
    <input id="playerId" type="number" formControlName="playerId" class="px-2 text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300">

    <label for="roles" class="px-2 bg-gray-800 border-2 border-gray-800 border-solid">Rollen</label>
    <ng-select id="roles" [items]="roles" bindLabel="name" bindValue="id" [multiple]="true" formControlName="roles" class="text-black"></ng-select>

    <label for="notes" class="px-2 bg-gray-800 border-2 border-gray-800 border-solid">Notiz</label>
    <textarea id="notes" formControlName="note" class="px-2 text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"></textarea>

    <div class="col-span-2 flex justify-between mt-4">
      <button type="submit" [disabled]="!userForm.valid" class="px-4 py-1 bg-gray-800 border border-gray-500 border-solid rounded-md hover:border-orange-300 hover:text-orange-300 disabled:opacity-50">Speichern</button>
      <button type="button" (click)="onCancel()" class="px-4 py-1 bg-gray-800 border border-gray-500 border-solid rounded-md hover:border-orange-300 hover:text-orange-300">Abbrechen</button>
    </div>

    <div *ngIf="userForm.errors?.['mismatch'] && userForm.get('passwordConfirmation')?.touched" class="col-span-2 text-red-500 text-sm mt-1">
      Passwörter stimmen nicht überein.
    </div>
  </form>
</section>
